import { Component, OnChanges, Input, SimpleChanges, Injector } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApAlertService } from 'webcommon/core-ui';
import { FcListValidationService } from '../../generic/fc-list-validation/fc-list-validation.service';
import { FcItemModalContext } from '../../../models';
import { FcInsurancePlanListItemDto, FormGroupValidationRules } from 'webcommon/shared';
import { FcItemListBaseComponent } from '../../generic';

@Component({
    providers: [ApAlertService, FcListValidationService],
    selector: 'fc-insurance-plan-clinical-tab',
    templateUrl: './fc-insurance-plan-clinical-tab.component.html',
})
export class FcInsurancePlanClinicalTabComponent extends FcItemListBaseComponent implements OnChanges {
    @Input() baseId: string;
    @Input() form: FormGroup;
    @Input() listItem: FcInsurancePlanListItemDto;
    @Input() isSubmitted = false;
    @Input() itemContext: FcItemModalContext;
    @Input() isDataLoaded: boolean;

    public selectedPreferredLaboratoriesPks: string[] = [];
    public selectedPaymentTypologyPks: string[] = [];

    // Form Controls
    public preferredLaboratoriesUidControl: FormControl = new FormControl<string[]>([]);
    public paymentTypologyUidControl: FormControl = new FormControl('');

    public listItemDefaultValidation: FormGroupValidationRules = {
        PreferredLaboratoriesUid: {
            IsRequired: false,
        },
        PayerTypologySourceUid: {
            IsRequired: false,
        },
    };

    constructor(
        injector: Injector,
    ) {
        super(injector);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.itemContext != null) {
            this.fcListValidation.initValidation(this.itemContext, this.listItemDefaultValidation);
        }
        if (changes.form != null) {
            this.addControlsToForm();
        }
        if ((changes.itemContext != null || changes.form != null || changes.listItem != null) && this.isDataLoaded) {
            this.setForm();
        }
    }

    private addControlsToForm(): void {
        this.form.addControl('preferredLaboratoriesUid', this.preferredLaboratoriesUidControl);
        this.form.addControl('paymentTypologyUid', this.paymentTypologyUidControl);

    }

    private setForm(): void {
        this.selectedPreferredLaboratoriesPks = this.getFindControlValue(this.listItem.PreferredLaboratoriesUid);
        this.selectedPaymentTypologyPks = this.getFindControlValue(this.listItem.PayerTypologySourceUid);
    }


    public getFindControlValidation(controlName: string): boolean {
        if (this.fcListValidation.validations[controlName]) {
            return !!this.fcListValidation.validations[controlName].IsRequired;
        } else {
            return !!this.listItemDefaultValidation[controlName].IsRequired;
        }
    }
}
